import React, {useEffect, useState} from 'react';
import {useParams, Link} from "react-router-dom";

import MindsetsJsSDK from "mindsets-js-sdk";
import AchievementOverview from './AchievementOverview/index.js';
import Development from './Development/index.js';
import Graduate from './Graduate/index.js';

import './teacher_skills_passport.scss';

export default function () {
    const {student_id} = useParams();
    const [allSkillData, setAllSkillData] = useState([]);

    useEffect(() => {
        MindsetsJsSDK().API.get(`skills_passport/skills_achievement`, {
            student_id: student_id ?? 40276
        }).then((response) => {
            console.log(response);
            setAllSkillData(response.skills);
        });
    }, [student_id]);

    console.log('allSkillData', allSkillData);

    return (
        <div id="teacher-skills-passport">
            <div className="container">
                <div className="section">
                    <h2 className="header-new">
                        {`Skills Passport`}
                    </h2>
                </div>

                <div className="section">
                    <div className="flex-row flex-h-end flex-gap-10">
                        <div>{`Sample:`}</div>
                        <Link to="/teacher/skills-passport/student/40276">Student 1</Link>
                        <Link to="/teacher/skills-passport/student/40298">Student 2</Link>
                        <Link to="/teacher/skills-passport/student/41795">Student 3</Link>
                        <Link to="/teacher/skills-passport/student/42134">Student 4</Link>
                        <Link to="/teacher/skills-passport/student/39850">Student 5</Link>
                    </div>
                </div>

                <AchievementOverview
                    allSkillData={allSkillData}
                />

                <div className="section"></div>
                <div className="section"></div>

                <Development
                    allSkillData={allSkillData}
                />

                <div className="section"></div>
                <div className="section"></div>

                <Graduate
                    allSkillData={allSkillData}
                />

                <div className="section"></div>

            </div>
        </div>
    );
}